import { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts";

const DepartureCausesPieChart = ({ data }) => {
  const [displayedData, setDisplayedData] = useState([]);
  const [restData, setRestData] = useState();

  useEffect(() =>  {
    if (data.length <= 7) setDisplayedData(data);
    else {
      const temp = data.slice(0, 7);
      const rest = data.slice(7);
      temp.push({
        reason: 'Autres',
        total: rest.reduce((sum, val) => sum + parseInt(val.total), 0),
        percentage: rest.reduce((sum, val) => sum + parseFloat(val.percentage), 0),
      });

      setDisplayedData(temp);
      setRestData(rest);
    }
  }, [data]);

  const getColorByIndex = (index) => {
    const colors = [
      "#34a853", // green
      "#ea4335", // red
      "#4285f4", // blue
      "#fbbc05", // yellow
      "#ff7043", // orange
      "#00acc1", // teal
      "#9c27b0", // purple
      "#fb8c00"  // dark orange
    ];
    return colors[index % colors.length];
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active) {
      const item = payload[0];
      const cardStyles = { padding: '12px', backgroundColor: '#fff', borderRadius: '2px', border: '1px solid #f1f1f1' };

      return (
        <div>
         <div style={cardStyles}>
            <span style={{ color: item.payload.fill}}>
              {item.value.toFixed(0)}% {item.payload.reason}
            </span>
            {item.name === 7 && (
              <div style={{ fontSize: '11px' }}>
                {restData.map((it, i) => (
                  <div>
                    - {it.reason ?? 'N/A'} : {it.percentage.toFixed(0)}%
                  </div>
                ))}
              </div>
            )}
         </div>
        </div>
      );
    }

    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={440}>
      <PieChart>
        <Pie
          data={displayedData}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ reason, percentage, total }) => {
            const text = total === 1 ? 'client' : 'clients';

            return `${reason} (${(percentage).toFixed(0)}%, ${total} ${text})`
          }}
          fontSize="12px"
          outerRadius={120}
          innerRadius={40}
          fill="#8884d8"
          dataKey="percentage"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={getColorByIndex(index)} />
          ))}
        </Pie>
        <Tooltip content={CustomTooltip} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default DepartureCausesPieChart;
